import { render, staticRenderFns } from "./TipsItem.vue?vue&type=template&id=46a09755&scoped=true&"
import script from "./TipsItem.vue?vue&type=script&lang=js&"
export * from "./TipsItem.vue?vue&type=script&lang=js&"
import style0 from "./TipsItem.vue?vue&type=style&index=0&id=46a09755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a09755",
  null
  
)

export default component.exports